export const suppressToast = (message: string | undefined): boolean => {
  if (message === undefined) return false;

  // Список сообщений, для которых не нужно показывать toast
  const suppressedMessages = [
    'Указанный заказ не найден',
    'Пришла ошибка - Указанный заказ не найден',
    'Произошла ошибка чтения ответа - Syntax error'
  ];

  return suppressedMessages.includes(message);
};
